// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__24jOB","colMaxWidth":"Table_colMaxWidth__1G_yP"};